import React from 'react';
import './InfoPanel.css';

const InfoPanel = (props) => {
  return (
    <div className="info-panel">
      <div className="info-panel__header">Current distance</div>
      <div className="info-panel__body" >
        <span className="font-red" >{props.currentDist.toFixed(1)}</span> / {props.fullDist} km</div>
    </div>
  )
}

export { InfoPanel as default }